module.exports = __webpack_public_path__ + "static/media/mi.9afbb93b.jpg";